import React from "react";
import "../CustomCSS/WhyUs.css";

const WhyUs = () => {
  const points = [
    { number: "1", text: "Natural Healing Methods" },
    { number: "2", text: "Affordable & Transparent Pricing" },
    { number: "3", text: "Expert Consultation" },
    { number: "4", text: "Trusted Results" },
  ];

  return (
    <section id='whyus' className="whyus-section">
      <h2 className="whyus-title">Why Choose Us?</h2>
      <div className="whyus-grid">
        {points.map((item, index) => (
          <div className="whyus-card" key={index}>
            <div className="whyus-icon">{item.number}</div>
            <p className="whyus-text">{item.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyUs;
